<template>
    <div>
        <div>
        </div>
        <div id="model-area">
            <a-modal
          v-model="visible"
          title="选择分类"
          @ok="getSelectId"
          centered
          okText="确定"
          cancelText="关闭"
        >
    <CatTree :currentCategory="selectId" @change="changeCategory"/>
        </a-modal>
        </div>
    </div>
</template>
<script>
import CatTree from '../CatTree';
export default {
  data(){
      return {
          selectId:"",
          visible:false
      }
  },
  props:["onSelect",],
    methods:{
        getSelectId(){
            this.onSelect(this.selectId);
            this.visible = false;
        },
        changeCategory(category){
            this.selectId = category.id;
        }
    },
    components:{
        CatTree
    },
}
</script>